import { useCallback, useLayoutEffect, useRef, useState } from 'react';
import { useEventListener } from 'usehooks-ts';
const FOOTER_RESERVE = 88;
const MIN_HEIGHT = 160;
const SCROLL_OPTIONS = {
  passive: true
};
export const useHeightAboveStickyFooter = isEnabled => {
  const ref = useRef(null);
  const [maxHeight, setMaxHeight] = useState();
  const measure = useCallback(() => {
    const element = ref.current;
    if (!isEnabled || !element) {
      return;
    }
    const available = window.innerHeight - element.getBoundingClientRect().top - FOOTER_RESERVE;
    setMaxHeight(Math.round(Math.max(available, MIN_HEIGHT)));
  }, [isEnabled]);
  useLayoutEffect(() => {
    measure();
  }, [measure]);
  useEventListener('resize', measure);
  useEventListener('scroll', measure, undefined, SCROLL_OPTIONS);
  return {
    maxHeight,
    ref
  };
};
//# sourceMappingURL=useHeightAboveStickyFooter.js.map